export default "__VITE_ASSET__a4d89c51__"